import angular from 'angular'

export default angular
    .module('outputManage.billManage.cancelInvoice', [])



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/cancelInvoiceModule.js